import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ConfigService} from '../config/config.service';
import { TranslateService } from '@ngx-translate/core';
import {LanguageService} from '../service/language.service';
import {UntypedFormControl, UntypedFormGroup, NgForm, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {filter, switchMap, tap} from 'rxjs/operators';
import {timer} from 'rxjs';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContactComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  constructor(private api: ConfigService, private translate: TranslateService,
              // tslint:disable-next-line:variable-name
              private _language: LanguageService, private snackBar: MatSnackBar) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }

  isLoaderVisible = false;
  isMailSent = false;
  errorMessage = '';
  otherDetails = '';
  // tslint:disable-next-line:typedef
  myForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    telephone: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    termsAndConditions: new UntypedFormControl(false, [Validators.requiredTrue]),
    confidentialityPolicy: new UntypedFormControl(false, [Validators.requiredTrue])
  });

  // tslint:disable-next-line:typedef
  get firstNameFormControl() {
    return this.myForm.get('firstName') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get lastNameFormControl() {
    return this.myForm.get('lastName') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get emailFormControl() {
    return this.myForm.get('email') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get telephoneFormControl() {
    return this.myForm.get('telephone') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get termsAndConditionsControl() {
    return this.myForm.get('termsAndConditions') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get confidentialityPolicyControl() {
    return this.myForm.get('confidentialityPolicy') as UntypedFormControl;
  }

  sendIdea(): void {
    const email = this.emailFormControl.value;
    const name = this.firstNameFormControl.value + ' ' + this.lastNameFormControl.value;
    const phone = this.telephoneFormControl.value;
    const message = '. tel: ' + phone + ' ' + this.otherDetails;

    this.isLoaderVisible = true;
    this.api.SendEmail(name, email, message).subscribe(
      data => {
        this.translate.get('requestSentSuccessfully').subscribe(snackbarMessage => {
          this.snackBar.open(snackbarMessage, '',
            {duration: 3000, panelClass: 'success-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
          this.isMailSent = true;
          this.isLoaderVisible = false;
        });
      },
      error => {
        // tslint:disable-next-line:no-shadowed-variable
        this.translate.get('errorOccurred').subscribe(snackbarMessage => {
          this.snackBar.open(snackbarMessage, '',
            {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
          this.isMailSent = false;
          this.isLoaderVisible = false;
        });
      });
  }

  ngOnInit(): void {
  }
}
